import React, { useState, useEffect, useMemo } from 'react';
import DataTable from 'react-data-table-component';

const Order = () => {
    const columns = [
        {
            name: <span className='font-weight-bold fs-13'>Id</span>,
            selector: row => row.id,
            sortable: true
        },
        {
            name: <span className='font-weight-bold fs-13'>User</span>,
            selector: row => row.user,
            sortable: true
        },
        {
            name: <span className='font-weight-bold fs-13'>Question</span>,
            selector: row => row.question,
            sortable: true
        },
        {
            name: <span className='font-weight-bold fs-13'>Option</span>,
            selector: row => row.option,
            sortable: true
        },
        {
            name: <span className='font-weight-bold fs-13'>Results</span>,
            selector: row => row.result,
            sortable: true
        },
    ];

    const data = useMemo(() => [
        {
            id: 1,
            user: "Tiger Nixon",
            question: "System Architect",
            option: "Edinburgh",
            result: "5421",
        },
        {
            id: 2,
            user: "Garrett Winters",
            question: "Accountant",
            option: "Tokyo",
            result: "8422",
        },
        {
            id: 3,
            user: "Ashton Cox",
            question: "Junior Technical Author",
            option: "San Francisco",
            result: "1562",
        },
        {
            id: 4,
            user: "Cedric Kelly",
            question: "Senior Javascript Developer",
            option: "Edinburgh",
            result: "6224",
        },
        {
            id: 5,
            user: "Airi Satou",
            question: "Accountant",
            option: "Tokyo",
            result: "5407",
        },
        {
            id: 6,
            user: "Brielle Williamson",
            question: "Integration Specialist",
            option: "New York",
            result: "4804",
        },
        {
            id: 7,
            user: "Herrod Chandler",
            question: "Sales Assistant",
            option: "San Francisco",
            result: "9608",
        },
        {
            id: 8,
            user: "Rhona Davidson",
            question: "Integration Specialist",
            option: "Tokyo",
            result: "6200",
        },
        {
            id: 9,
            user: "Colleen Hurst",
            question: "Javascript Developer",
            option: "San Francisco",
            result: "2360",
        },
        {
            id: 10,
            user: "Sonya Frost",
            question: "Software Engineer",
            option: "Edinburgh",
            result: "1667",
        },
        {
            id: 11,
            user: "Jena Gaines",
            question: "option Manager",
            option: "London",
            result: "3814",
        },
        {
            id: 12,
            user: "Quinn Flynn",
            question: "Support Lead",
            option: "Edinburgh",
            result: "9497",
        },
        {
            id: 13,
            user: "Charde Marshall",
            question: "Regional Director",
            option: "San Francisco",
            result: "6741",
        },
        {
            id: 14,
            user: "Haley Kennedy",
            question: "Senior Marketing Designer",
            option: "London",
            result: "3597",
        },
        {
            id: 15,
            user: "Tatyana Fitzpatrick",
            question: "Regional Director",
            option: "London",
            result: "1965",
        },
    ], []);

    const [pending, setPending] = useState(true);
    const [rows, setRows] = useState([]);
    useEffect(() => {
        const timeout = setTimeout(() => {
            setRows(data);
            setPending(false);
        }, 2000);
        return () => clearTimeout(timeout);
    }, [data]);

    return (
        <DataTable
            columns={columns}
            pagination
            data={rows}
            progressPending={pending}
        />
    );
}

export default Order